export default __webpack_public_path__ + "static/media/facebook.d1ce2d1a.svg";